// Shared YouTube helpers for product gallery videos — used by the Admin
// "Add Video" form (GalleryManager.jsx) and every product detail page that
// renders a YouTube gallery video (Bush Cabin, Awning, Roof Tent, Ground
// Tent, X-Series).

// Extracts an 11-char YouTube video ID from any common URL format
// (youtu.be, youtube.com/watch, /embed/, /shorts/), or returns the input
// unchanged if it's already a bare 11-char ID.
export const extractYoutubeId = (input) => {
  if (!input) return null;
  const trimmed = input.trim();
  const match = trimmed.match(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|watch\?v=|shorts\/))([a-zA-Z0-9_-]{11})/);
  if (match) return match[1];
  return /^[a-zA-Z0-9_-]{11}$/.test(trimmed) ? trimmed : null;
};

// Builds the gallery-viewer embed URL for a YouTube video ID.
//
// IMPORTANT: deliberately no `autoplay=1`. YouTube's iframe player returns
// "Video unavailable / This content isn't available" for some videos when
// autoplay is requested without an `origin=` param matching the referrer —
// confirmed via testing_agent iteration_125. Without autoplay the video
// loads to a normal clickable YouTube thumbnail/play button, which also
// matches expected UX for a gallery viewer users tap through.
export const buildYoutubeEmbedUrl = (id) => `https://www.youtube.com/embed/${id}?rel=0`;
